import { render } from "./Settings.vue?vue&type=template&id=5308a208&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=5308a208&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5308a208"],['__file',"src/pages/ddv-home/Settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5308a208"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5308a208', __exports__)) {
    api.reload('5308a208', __exports__)
  }
  
  module.hot.accept("./Settings.vue?vue&type=template&id=5308a208&scoped=true", () => {
    api.rerender('5308a208', render)
  })

}


export default __exports__